import { isMobile } from "react-device-detect";

export const LOGO_FONT_SIZE: number = isMobile ? 16 : 32;
export const SPACING = 8;
export const CHILD_WIDTH_PERCENTAGE = "90%";